var SwrFetcher = function SwrFetcher(url, token) {
  var headers = token ? {
    Authorization: "Bearer ".concat(token)
  } : undefined;
  return fetch(url, {
    headers: headers
  }).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

export { SwrFetcher };
